;(() => {
  window.jQuery = window.$

  // cash-dom dimension/scroll shims — cash v8 ships neither dimensions
  // nor scroll position helpers. Re-add jQuery-compatible wrappers on
  // $.fn so that existing front code keeps working unchanged.
  const fn = $.fn

  // cash-dom compatibility patch: jQuery's .attr(name, false) removes the
  // attribute; cash-dom's .attr calls setAttribute unconditionally, so
  // `.attr("disabled", false)` leaves the element with `disabled="false"`
  // — still truthy as an HTML boolean attribute. Route boolean `false` to
  // removeAttribute so existing jQuery-style call sites keep working.
  const originalAttr = fn.attr
  fn.attr = function attrFn(name, value) {
    if (typeof name !== "string" || arguments.length < 2) {
      return originalAttr.apply(this, arguments)
    }
    if (value === false) {
      return this.removeAttr(name)
    }
    return originalAttr.call(this, name, value)
  }

  // cash-dom compatibility patch: cash 8.x's `.trigger(name)` synthesizes
  // events via `document.createEvent(...)` + `event.initEvent(...)`. Some
  // browser extensions monkey-patch `document.createEvent` with broken `this`
  // bindings, causing `TypeError: Illegal invocation` for every `.trigger()`
  // call on the page. Use modern Event / MouseEvent constructors instead so
  // the extension's hook is never reached.
  const originalTrigger = fn.trigger
  const eventsMouseRe =
    /^(?:click|dblclick|contextmenu|mouse(?:down|up|move|over|out|enter|leave))$/
  const eventsHover = { mouseenter: "mouseover", mouseleave: "mouseout" }
  const eventsFocus = { focus: "focusin", blur: "focusout" }

  fn.trigger = function triggerFn(event, data) {
    if (typeof event !== "string") {
      return originalTrigger.apply(this, arguments)
    }
    const [nameOriginal, ...nsParts] = event.split(".")
    if (!nameOriginal) return this
    const name =
      eventsHover[nameOriginal] || eventsFocus[nameOriginal] || nameOriginal
    const opts = { bubbles: true, cancelable: true }
    const evt = eventsMouseRe.test(name)
      ? new MouseEvent(name, opts)
      : new Event(name, opts)
    evt.namespace = nsParts.sort().join(".")
    evt.___ot = nameOriginal
    evt.___td = data
    const isFocus = nameOriginal in eventsFocus
    return this.each((_i, ele) => {
      if (isFocus && typeof ele[nameOriginal] === "function") {
        ele[`___i${evt.type}`] = true
        ele[nameOriginal]()
        ele[`___i${evt.type}`] = false
      }
      ele.dispatchEvent(evt)
    })
  }

  fn.width = function widthFn(val) {
    if (val === undefined) {
      if (!this[0]) return undefined
      if (this[0] === window) return window.innerWidth
      if (this[0] === document) return document.documentElement.clientWidth
      return parseFloat(getComputedStyle(this[0]).width)
    }
    this[0].style.width = typeof val === "number" ? `${val}px` : val
    return this
  }

  fn.height = function heightFn(val) {
    if (val === undefined) {
      if (!this[0]) return undefined
      if (this[0] === window) return window.innerHeight
      if (this[0] === document) return document.documentElement.clientHeight
      return parseFloat(getComputedStyle(this[0]).height)
    }
    this[0].style.height = typeof val === "number" ? `${val}px` : val
    return this
  }

  fn.innerWidth = function innerWidthFn() {
    return this[0] ? this[0].clientWidth : undefined
  }
  fn.innerHeight = function innerHeightFn() {
    return this[0] ? this[0].clientHeight : undefined
  }

  fn.outerWidth = function outerWidthFn(includeMargin) {
    if (!this[0]) return undefined
    if (this[0] === window) return window.innerWidth
    let w = this[0].offsetWidth
    if (includeMargin) {
      const s = getComputedStyle(this[0])
      w += parseFloat(s.marginLeft) + parseFloat(s.marginRight)
    }
    return w
  }

  fn.outerHeight = function outerHeightFn(includeMargin) {
    if (!this[0]) return undefined
    if (this[0] === window) return window.innerHeight
    let h = this[0].offsetHeight
    if (includeMargin) {
      const s = getComputedStyle(this[0])
      h += parseFloat(s.marginTop) + parseFloat(s.marginBottom)
    }
    return h
  }

  fn.scrollTop = function scrollTopFn(val) {
    if (val === undefined) {
      if (!this[0]) return undefined
      if (this[0] === window || this[0] === document) return window.pageYOffset
      return this[0].scrollTop
    }
    const target =
      this[0] === window || this[0] === document
        ? document.documentElement
        : this[0]
    target.scrollTop = val
    return this
  }

  fn.scrollLeft = function scrollLeftFn(val) {
    if (val === undefined) {
      if (!this[0]) return undefined
      if (this[0] === window || this[0] === document) return window.pageXOffset
      return this[0].scrollLeft
    }
    const target =
      this[0] === window || this[0] === document
        ? document.documentElement
        : this[0]
    target.scrollLeft = val
    return this
  }
})()
